(function () {
  const shopifyPrivacyPath = '/policies/privacy-policy';
  const customPrivacyPath = '/pages/informativa-privacy';

  function updatePrivacyPolicyLinks(root) {
    const scope = root instanceof Element ? root : document;
    const links = scope.querySelectorAll(`a[href*="${shopifyPrivacyPath}"]`);

    links.forEach((link) => {
      const href = link.getAttribute('href');

      if (!href || !href.includes(shopifyPrivacyPath)) return;

      const url = new URL(href, window.location.origin);
      url.pathname = customPrivacyPath;
      link.href = url.toString();
    });
  }

  function startObserver() {
    updatePrivacyPolicyLinks(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches(`a[href*="${shopifyPrivacyPath}"]`)) {
            updatePrivacyPolicyLinks(node.parentElement || document);
            return;
          }

          updatePrivacyPolicyLinks(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
